import { useSelector } from "react-redux";
import { dashAddressesTags, dashCreditTags, dashJobsTags, dashOrderTags, dashQuoteTags } from "@components/Components/Reusables/CRM/KeyValuePairs";
import useFetch from "./useFetch";
import { buildObjectFromString } from "@components/config/helpers";


const usePreferences = (type = null, system_preferences = []) => {
	const user = useSelector((state) => state.authReducer.user);
	const default_system_preferences = useSelector((state) => state.dashboardReducer?.system_preferences);
	const { preferences } = user;
	const preferencesReady = useSelector((state) => state.authReducer?.user?.preferences?.preferencesReady);

	const { post, data, response, loading, error } = useFetch(false);

	const preferenceCheck = (preference_type, user = 'user', type_switch = false) => {
		const preference = preferences?.data?.[user]?.find(preference => preference.name_alias == preference_type);
		let value;
		if (preference) {
			value = preference.user_preference;
		}
		else {
			if (type_switch) {
				value = 'No';
			}
			else {
				// const default_pref = preferences?.data?.[user]?.find(preference => preference.name_alias == preference_type);
				if (default_system_preferences?.length == 0) return 'default';
				const merged = [...(default_system_preferences?.data?.user || []), ...(default_system_preferences?.data?.agent || [])];
				const defaultValue = merged.find(pref => pref.name_alias == preference_type)?.default_value;
				if (defaultValue == null) return 'default';
				return defaultValue;
			}
		}
		return value;
	}

	// QUOTE PREFERENCES

	const quoteEmailPopup = () => preferenceCheck('quote_email_popup', 'agent')
	const quoteStatusRedirect = () => preferenceCheck('quote_status_redirect', 'agent')
	const quotePaymentRedirect = () => preferenceCheck('quote_payment_redirect', 'agent')
	const quoteDefaultBrand = () => preferenceCheck('default_brand', 'agent')
	const quoteAddressesPopup = () => preferenceCheck('quote_addresses_popup', 'agent')

	// END OF QUOTE PREFERENCES


	// ORDER PREFERENCES
	// END OF ORDER PREFERENCES

	// LOGIN PREFERENCES
	const loginLandingPage = () => preferenceCheck('login_landing_page', 'user')
	// END OF LOGIN PREFERENCES

	// Agent General PREFERENCES

	const startWithExpandedCommLog = (type) => {
		// customer_full_comm_log OR quote_order_full_comm_log
		if (preferenceCheck(type, 'agent', true) == 'Yes') {
			return true;
		}
		else {
			return false;
		}
	}

	// END OF Agent General PREFERENCES


	// DASHBOARD

	const getDashboardView = () => preferenceCheck('dashboard_table_view')
	const getDashboardTableColumns = () => preferenceCheck('dashboard_table_columns')
	const dashboardQuoteColumns = () => preferenceCheck('dashboard_quote_columns', 'agent');
	const dashboardOrderColumns = () => preferenceCheck('dashboard_order_columns', 'agent');

	const getDashboardTableSort = (type) => {
		const sort = preferenceCheck(type, 'agent')

		// Return empty sort if default
		if (sort == 'default') {
			return [];
		}

		let tags = null;

		switch (type) {
			case 'dashboard_orders_sort':
				tags = dashOrderTags()

				break;
			case 'dashboard_quotes_sort':
				tags = dashQuoteTags()

				break;
			case 'dashboard_credits_sort':
				tags = dashCreditTags()

				break;
			case 'dashboard_jobs_sort':
				tags = dashJobsTags()

				break;
			case 'dashboard_addresses_sort':
				tags = dashAddressesTags();

				break;

			default:
				break;
		}

		if (!sort || !tags.length) return [];

		return sort.split(', ').map(value => {
			const [field, direction] = value.split(': ');

			const tag = tags.find(tag => tag.value === field.trim());
			if (tag) {
				return { field: tag.key, sort: direction.trim() };
			} else {
				return null;
			}
		}).filter(Boolean);

	}
	const getDashboardCommLogSort = () => preferenceCheck('dashboard_comm_log_sort', 'agent')
	const getDashboardPaginationState = () => preferenceCheck('customer_history_table_pagination', 'agent')

	//END OF DASHBOARD

	const simplifiedQuoteOrderView = () => preferenceCheck('simplified_quote_order_view', 'agent');
	const sameAsButtons = () => preferenceCheck('same_as_buttons', 'agent');
	const defaultQuickEditMode = () => preferenceCheck('quick_edit_mode', 'agent');
	const defaultStockChecks = () => preferenceCheck('initial_stock_checks', 'agent');


	// Quote table pagination
	const quoteTablePagination = () => preferenceCheck('quote_table_pagination', 'agent');
	const quoteTableColumns = () => preferenceCheck('quote_table_columns', 'agent');
	const quoteFontFamily = () => preferenceCheck('font_family', 'agent');

	const orderTableColumns = () => preferenceCheck('order_table_columns', 'agent');
	// settings
	const tableFontSize = () => preferenceCheck('table_font_size', 'agent');
	const tableRowHeight = () => preferenceCheck('table_row_height', 'agent');

	// Order
	const addonPopup = () => preferenceCheck('order_addon_popup', 'agent');

	// Schedule
	const scheduleSelectAllAgents = () => preferenceCheck('schedule_select_all_agents', 'agent')

	// Widget Preferences
	const widgetFilters = (widgetName, buildObject = false) => {
		const preference = preferenceCheck(widgetName, 'agent');

		if (buildObject && typeof preference === 'string') {
			const trimmed = preference.trim();
			// Checks the object is a string and not an array
			if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
				try {
					return JSON.parse(trimmed);
				} catch (e) {
					console.error(`Failed to parse widget preference as JSON: ${widgetName}`, e);
				}
			}
			return buildObjectFromString(preference);
		}

		return preference;
	}



	return {
		quotePreferences: {
			quoteEmailPopup,
			quoteStatusRedirect,
			quotePaymentRedirect,
			quoteDefaultBrand,
			quoteAddressesPopup,
			sameAsButtons,
			defaultQuickEditMode,
			defaultStockChecks

		},
		orderPreferences: {
			addonPopup
		},
		quoteOrderPreferences: {
			simplifiedQuoteOrderView,
		},
		schedulePreferences: {
			scheduleSelectAllAgents
		},
		loginPreferences: {
			loginLandingPage
		},
		agentGeneral: {
			startWithExpandedCommLog
		},
		dashboardPreferences: {
			getDashboardView,
			getDashboardTableColumns,
			getDashboardTableSort,
			getDashboardCommLogSort,
			getDashboardPaginationState,
			dashboardQuoteColumns,
			dashboardOrderColumns,

		},
		quoteTable: {
			quoteTablePagination,
			quoteTableColumns,
			quoteFontFamily
		},
		orderTable: {
			orderTableColumns,
		},
		settings: {
			tableFontSize,
			tableRowHeight
		},
		widgets: {
			widgetFilters
		},
		request: {
			data,
			response,
			loading,
			error
		},
		preferencesReady
	}
}

export default usePreferences;